/**
 * creditCardIconSingleton.js
 * Created by Destin Frasier 9/18/17
 */

import { IconSingleton } from '../iconSingleton';

class CreditCardIconSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-credit-cards.loaded';
        this.svgPath = `${process.env.CDN}/graphics/creditCardIcons.svg`;
    }
}

const instance = new CreditCardIconSingleton();
export default instance;
